import type { PortalTypeForContext } from "~contexts/outfitter-provider"
import { usePortalEntitiesContext } from "~contexts/outfitter-provider"
import { useUser } from "~contexts/user-provider"
import { useDashboardNavigationMenuQuery } from "~graphql/dashboard.generated"
import { PortalType } from "~graphql/generated/types"

export default function useDashboardNavigationMenu() {
    const { isAdminNotImpersonating } = useUser()
    const { portalType, outfitterId, eventOrganizerId } =
        usePortalEntitiesContext()

    const portalEntityId = getPortalEntityId({
        portalType,
        outfitterId,
        eventOrganizerId,
    })
    const entityIdIfNeeded = isAdminNotImpersonating || Boolean(portalEntityId)

    const {
        data,
        previousData,
        loading: isLoading,
        error,
    } = useDashboardNavigationMenuQuery({
        variables: {
            portalType: portalType ?? PortalType.Outfitter,
            portalEntityId: portalEntityId ?? "",
        },
        skip: !entityIdIfNeeded || !portalType,
    })
    const menuGroups =
        data?.dashboardNavigationMenu ??
        previousData?.dashboardNavigationMenu ??
        []
    const isInitialLoading = isLoading && !menuGroups.length

    return { menuGroups, isLoading: isInitialLoading, error }
}

function getPortalEntityId({
    portalType,
    outfitterId,
    eventOrganizerId,
}: {
    portalType: PortalTypeForContext
    outfitterId: string | undefined | null
    eventOrganizerId: string | undefined | null
}) {
    return portalType === PortalType.Outfitter ? outfitterId : eventOrganizerId
}
